
export default {
    name: 'author',
    props: ['source', 'ranking'],
    data() {
        return {

        }
    },
    watch: {
        source(val) {
            this.source = val
        }
    },
    methods: {

        async focusOn(item) {
            //关注用户
            let res = await this.$global.doFollow({ "fid": item.uid })
            // res.code == '200' ? this.$parent.getAuthor() : this.$message.error('Error');
            res.code == '200' ? (item.is_follow = 1, this.$message(res.msg)) : ''
        },
        async unsubscribe(item) {
            //取消关注用户
            let res = await this.$global.unFollow({ "fid": item.uid })
            // res.code == '200' ? this.$parent.getAuthor() : this.$message.error('Error');
            res.code == '200' ? (item.is_follow = 0, this.$message(res.msg)) : ''
        }
    }
}
